import auth from './auth.json';

// This file mostly exists to simplify before we are able to move translations to backend
const esES = { translation: {}, auth };

export default esES;
